import React, { useEffect } from 'react';
import classnames from 'classnames';
import FrameworkContext from '../FrameworkContext';
import { useRedux } from '../../hooks';
import DefaultPCHeader from '../components/DefaultHeader';
import DefaultPCSimpleHeader from '../components/DefaultSimpleHeader';
import DefaultPCSiderBar from '../../sider-bar/SiderBar';
import './index.less';

interface IProps {
  children: React.ReactNode,
  defaultVisibleHeader?: boolean, // 默认true
  defaultVisibleSiderBar?: boolean // 默认true
  defaultHeader?: React.ReactNode,
  defaultSiderBar?: React.ReactNode,
  defaultVisibleCity?: boolean,
  defaultVisibleSimpleHeader?: any
}

const FrameworkPC: React.FC<IProps> = ({
  children,
  defaultVisibleHeader = true,
  defaultVisibleSiderBar = true,
  defaultHeader,
  defaultSiderBar,
  defaultVisibleCity = false,
  defaultVisibleSimpleHeader = false,
}: IProps) => {
  const [state, dispatch] = useRedux();

  const {
    header,
    visibleHeader,
    visibleSimpleHeader,
    headerClassName,
    siderBar,
    visibleSiderBar,
    className,
  } = state;

  useEffect(() => {
    dispatch({
      payload: {
        header: defaultHeader || null,
        visibleHeader: defaultVisibleHeader,
        siderBar: defaultSiderBar || null,
        visibleSiderBar: defaultVisibleSiderBar,
        defaultSetting: {
          frameworkDefaultVisibleHeader: defaultVisibleHeader,
          frameworkDefaultHeader: defaultHeader || null,
          frameworkDefaultVisibleSiderBar: defaultVisibleSiderBar,
          frameworkDefaultSiderBar: defaultSiderBar || null,
          frameworkDefaultVisibleCity: defaultVisibleCity,
          frameworkDefaultSimpleHeader: defaultVisibleSimpleHeader,
        },
        visibleCity: defaultVisibleCity,
        visibleSimpleHeader: defaultVisibleSimpleHeader,
      },
    });
  }, [dispatch, defaultHeader, defaultSiderBar,
    defaultVisibleHeader,
    defaultVisibleSiderBar, defaultVisibleCity, defaultVisibleSimpleHeader,
  ]);

  return (
    <FrameworkContext.Provider value={{ state, dispatch }}>
      <div className={classnames('framework-pc-container', className)}>
        {
          visibleHeader && (
            <div className={headerClassName || ''}>
                {
                header
                || (
                  visibleSimpleHeader === true && <DefaultPCSimpleHeader />
                  || visibleSimpleHeader === false && <DefaultPCHeader />
                )
              }
            </div>
          )
        }
        {children}
        {
          visibleSiderBar && (siderBar || <DefaultPCSiderBar />)
        }
      </div>
    </FrameworkContext.Provider>
  );
};

export default FrameworkPC;
